









































































































import Vue, { PropType } from "vue";
import FloatingMenu from "@/components/Molecules/FloatingMenu/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Radio from "@/components/Atoms/Forms/Radio/index.vue";
import Button from "@/components/Atoms/Button/index.vue";
import Body from "@/components/Atoms/Typography/Body/index.vue";
import SearchSelectField from "@/components/Atoms/Forms/SearchSelectField/index.vue";
import LoadingIcon from "@/components/Atoms/LoadingIcon/index.vue";
import { ApiResponse } from "@/api/types";

import { debounce } from "lodash";
import { CombinedVueInstance } from "vue/types/vue";
import { getCompanies } from "@/api";

enum CompareType {
  AVERAGE = "average",
  COMPANY = "company"
}

export interface Props {
  companyId: string;
}
export interface Data {
  loading: boolean;
  isShowFloating: boolean;
  compareType: CompareType;
  searchSelectFieldInputValue: string;
  searchedCompanies: ApiResponse.CompaniesExplorer["companies"];
  recommendCompanies: ApiResponse.CompaniesExplorer["companies"];
  selectedCompanyId?: string;
}
export interface Computed {
  disableSubmit: boolean;
  suggestionCompanies: ApiResponse.CompaniesExplorer["companies"];
}
export interface Methods {
  toggleChangeCompareMenu: () => void;
  handleChange: (value: Data["compareType"]) => void;
  handleClickSubmit: () => void;
  handleClickSuggestionCompany: (id: string) => void;
  handleSearchSelectFieldInput: (inputValue: string) => void;
  getRecommendCompanies: () => void;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "CompanyCompareButton",
  components: {
    Heading,
    Body,
    Button,
    FloatingMenu,
    Radio,
    SearchSelectField,
    LoadingIcon
  },
  props: {
    companyId: {
      type: String as PropType<Props["companyId"]>,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      isShowFloating: false,
      compareType: CompareType["AVERAGE"],
      searchSelectFieldInputValue: "",
      recommendCompanies: [],
      searchedCompanies: [],
      selectedCompanyId: undefined
    };
  },
  computed: {
    disableSubmit() {
      if (this.compareType === CompareType["AVERAGE"]) {
        return false;
      } else {
        return !this.selectedCompanyId;
      }
    },
    suggestionCompanies() {
      let suggestionCompanies: Computed["suggestionCompanies"];
      if (this.searchedCompanies.length) {
        suggestionCompanies = this.searchedCompanies;
      } else if (this.searchSelectFieldInputValue) {
        suggestionCompanies = [];
      } else {
        suggestionCompanies = this.recommendCompanies;
      }
      return suggestionCompanies.filter(
        suggestionCompany => String(suggestionCompany.id) !== this.companyId
      );
    }
  },
  mounted() {
    this.getRecommendCompanies();
  },
  methods: {
    handleChange(value) {
      this.compareType = value;
    },
    handleClickSubmit() {
      switch (this.compareType) {
        case CompareType["AVERAGE"]:
          this.$router
            .push({
              name: "CompanyCompare",
              params: { companyId: String(this.companyId) },
              query: {
                type: CompareType["AVERAGE"]
              }
            })
            .catch(err => err);
          break;

        case CompareType["COMPANY"]:
          this.selectedCompanyId &&
            this.$router
              .push({
                name: "CompanyCompare",
                params: { companyId: String(this.companyId) },
                query: {
                  type: CompareType["COMPANY"],
                  companyId: this.selectedCompanyId
                }
              })
              .catch(err => err);
          break;
      }
      this.toggleChangeCompareMenu();
    },
    toggleChangeCompareMenu() {
      this.isShowFloating = !this.isShowFloating;
    },
    handleClickSuggestionCompany(companyId: string) {
      this.selectedCompanyId = companyId;
    },
    handleSearchSelectFieldInput: debounce(async function(
      this: CombinedVueInstance<Vue, Data, Methods, Computed, Props>,
      inputValue: string
    ) {
      this.searchSelectFieldInputValue = inputValue;

      if (!inputValue) {
        this.searchedCompanies = [];
      } else {
        try {
          this.loading = true;
          const response = await getCompanies({
            company_name: inputValue
          });
          this.searchedCompanies = response.data.companies;
        } finally {
          this.loading = false;
        }
      }
    },
    500),
    async getRecommendCompanies() {
      try {
        this.loading = true;
        const response = await getCompanies({
          limit: 5
        });
        this.recommendCompanies = response.data.companies;
      } finally {
        this.loading = false;
      }
    }
  }
});
